export function formatDuration(minutes) {
  const total = Number(minutes) || 0;
  if (total <= 0) return '—';
  if (total < 60) return `${total} min`;

  const hours = Math.floor(total / 60);
  const mins = total % 60;
  return mins > 0 ? `${hours}hr ${mins} min` : `${hours}hr`;
}

export function formatSecondsDuration(totalSeconds) {
  const total = Math.max(0, Math.round(Number(totalSeconds) || 0));
  if (total <= 0) return '—';
  if (total < 60) return `${total} sec`;

  const hours = Math.floor(total / 3600);
  const mins = Math.floor((total % 3600) / 60);
  const secs = total % 60;

  if (hours > 0) {
    return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
  }

  if (secs > 0 && mins < 5) {
    return `${mins}:${String(secs).padStart(2, '0')} min`;
  }

  return `${mins} min`;
}
